export interface Country {
  name: string;
  isoCode: string;
  /** Aliases for search (e.g. "US", "USA" for United States) */
  aliases?: string[];
}

export const countries: Country[] = [
  { name: 'India', isoCode: 'IN', aliases: ['in'] },
  {
    name: 'United States',
    isoCode: 'US',
    aliases: ['us', 'usa', 'united states of america'],
  },
  { name: 'Afghanistan', isoCode: 'AF' },
  { name: 'Albania', isoCode: 'AL' },
  { name: 'Algeria', isoCode: 'DZ' },
  { name: 'Andorra', isoCode: 'AD' },
  { name: 'Angola', isoCode: 'AO' },
  { name: 'Argentina', isoCode: 'AR' },
  { name: 'Armenia', isoCode: 'AM' },
  { name: 'Australia', isoCode: 'AU' },
  { name: 'Austria', isoCode: 'AT' },
  { name: 'Bangladesh', isoCode: 'BD' },
  { name: 'Belgium', isoCode: 'BE' },
  { name: 'Brazil', isoCode: 'BR' },
  { name: 'Canada', isoCode: 'CA' },
  { name: 'China', isoCode: 'CN' },
  { name: 'Denmark', isoCode: 'DK' },
  { name: 'Egypt', isoCode: 'EG' },
  { name: 'Finland', isoCode: 'FI' },
  { name: 'France', isoCode: 'FR' },
  { name: 'Germany', isoCode: 'DE' },
  { name: 'Greece', isoCode: 'GR' },
  { name: 'Indonesia', isoCode: 'ID' },
  { name: 'Ireland', isoCode: 'IE' },
  { name: 'Italy', isoCode: 'IT' },
  { name: 'Japan', isoCode: 'JP' },
  { name: 'Kenya', isoCode: 'KE' },
  { name: 'Malaysia', isoCode: 'MY' },
  { name: 'Mexico', isoCode: 'MX' },
  { name: 'Netherlands', isoCode: 'NL' },
  { name: 'New Zealand', isoCode: 'NZ' },
  { name: 'Norway', isoCode: 'NO' },
  { name: 'Pakistan', isoCode: 'PK' },
  { name: 'Philippines', isoCode: 'PH' },
  { name: 'Poland', isoCode: 'PL' },
  { name: 'Portugal', isoCode: 'PT' },
  { name: 'Russia', isoCode: 'RU' },
  { name: 'Saudi Arabia', isoCode: 'SA' },
  { name: 'Singapore', isoCode: 'SG' },
  { name: 'South Africa', isoCode: 'ZA' },
  { name: 'South Korea', isoCode: 'KR' },
  { name: 'Spain', isoCode: 'ES' },
  { name: 'Sri Lanka', isoCode: 'LK' },
  { name: 'Sweden', isoCode: 'SE' },
  { name: 'Switzerland', isoCode: 'CH' },
  { name: 'Thailand', isoCode: 'TH' },
  { name: 'Turkey', isoCode: 'TR' },
  { name: 'Ukraine', isoCode: 'UA' },
  { name: 'United Arab Emirates', isoCode: 'AE' },
  { name: 'United Kingdom', isoCode: 'GB' },
  { name: 'Vietnam', isoCode: 'VN' },
];

export const indiaStates: string[] = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
  'Andaman and Nicobar Islands',
  'Chandigarh',
  'Dadra and Nagar Haveli and Daman and Diu',
  'Delhi',
  'Jammu and Kashmir',
  'Ladakh',
  'Lakshadweep',
  'Puducherry',
];

export const usaStates: string[] = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

/** Indian states plus "National" for national-level registration authorities */
export const registrationStateOptions: string[] = ['National', ...indiaStates];

export function getStatesForCountry(countryName: string): string[] | null {
  if (!countryName?.trim()) return null;
  const name = countryName.trim();
  const lower = name.toLowerCase();
  // India (exact or case-insensitive)
  if (lower === 'india') return indiaStates;
  // United States / USA / US
  if (
    lower === 'united states' ||
    lower === 'usa' ||
    lower === 'us' ||
    lower === 'united states of america'
  )
    return usaStates;
  return null;
}
